<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="images" src="images/f011-01.jpg" width="80%"/></p>
<p class="caption"><em class="italic">The dark and sombre appearance of the German cemetery at Sailly-sur-la-Lys</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 12_fm027.vue?61e579bc